import React from "react";
import {css, Theme} from "@emotion/react";

import {backgroundColor, zIndex} from "@pg-design/helpers-css";

interface IProps {
    zIndex: number;
    onClick?: () => void;
    className?: string;
}

export const PageOverlay = (props: IProps) => {
    return <div css={[overlayStyle, zIndex(props.zIndex)]} onClick={props.onClick} className={props.className}></div>;
};

const overlayStyle = (theme: Theme) => css`
    position: fixed;
    inset: 0;
    ${backgroundColor(theme.colors.secondary)};
    opacity: 0.75;
`;
import React from "react";
import {css, Theme} from "@emotion/react";

import {backgroundColor, zIndex} from "@pg-design/helpers-css";

interface IProps {
    zIndex: number;
    onClick?: () => void;
    className?: string;
}

export const PageOverlay = (props: IProps) => {
    return <div css={[overlayStyle, zIndex(props.zIndex)]} onClick={props.onClick} className={props.className}></div>;
};

const overlayStyle = (theme: Theme) => css`
    position: fixed;
    inset: 0;
    ${backgroundColor(theme.colors.secondary)};
    opacity: 0.75;
`;
